export function paginateArray<T>(
  items: T[],
  pageSize: number,
  pageIndex: number,
): T[] {
  const startIndex = pageIndex * pageSize;
  const endIndex = startIndex + pageSize;
  return items.slice(startIndex, endIndex);
}
